import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const buildNextUrl = (state) => {
    return state.app.nextPage
        .replace("{currentProject}", state.app.currentProject)
}